if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', class VariantSelects extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('change', this.onVariantChange);
        }

        onVariantChange() {
            this.updateOptions();
            this.updateMasterId();
            this.toggleAddButton(false, '', false);
            this.updatePickupAvailability();
            this.removeErrorMessage();
            if (!this.currentVariant) {
                this.toggleAddButton(true, '', true);
                this.setUnavailable();
            }else{
                this.updateURL();
                this.updateVariantInput();
                this.renderProductInfo();
            }
        }

        updateOptions() {  
            const products = Array.from(this.querySelectorAll('.product-options-container'));
            this.options = products.map((product) => {
                return Array.from(product.querySelectorAll('input')).find((radio) => radio.checked).value;
            });
        }

        updateMasterId() {
            this.currentVariant = this.getVariantData().find((variant) => {
              return !variant.options.map((option, index) => {
                return this.options[index] === option;
              }).includes(false);
            });
        }

        getVariantData() {
            this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
            return this.variantData;
        }

        toggleAddButton(disable = true, text, modifyClass = true) {
            const productForm = document.getElementById(`product-form-${this.dataset.section}`);
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            const addButtonText = productForm.querySelector('[name="add"] > span');
            if (!addButton) return;
        
            if (disable) {
              addButton.setAttribute('disabled', 'disabled');
              if (text) addButtonText.textContent = text;
            } else {
              addButton.removeAttribute('disabled');
              addButtonText.textContent = window.variantStrings.addToCart;
            }
        
            if (!modifyClass) return;
        }

        setUnavailable() {
            const button = document.getElementById(`product-form-${this.dataset.section}`);
            const addButton = button.querySelector('[name="add"]');
            const addButtonText = button.querySelector('[name="add"] > span');
            const price = document.getElementById(`price-${this.dataset.section}`);
            const priceUnavailable = document.getElementById(`price-unavailable-${this.dataset.section}`);
            if (!addButton) return;
            addButtonText.textContent = window.variantStrings.unavailable;
            if (price) {
                price.classList.add('visually-hidden');
                priceUnavailable.classList.add('visually-visible');
            }
        }

        updateURL() {
            if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
            window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        updateVariantInput() {
            const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
            productForms.forEach((productForm) => {
              const input = productForm.querySelector('input[name="id"]');
              input.value = this.currentVariant.id;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            });
        }

        renderProductInfo() {
            fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                if (source && destination) destination.innerHTML = source.innerHTML;
        
                const price = document.getElementById(`price-${this.dataset.section}`);
                const priceUnavailable = document.getElementById(`price-unavailable-${this.dataset.section}`);
        
                if (price) {
                    price.classList.remove('visually-hidden');
                    priceUnavailable.classList.remove('visually-visible');
                } 
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
              });
        }

        removeErrorMessage() {
            const section = this.closest('section');
            if (!section) return;
        
            const productForm = section.querySelector('product-form');
            if (productForm) productForm.handleErrorMessage();
        }

        updatePickupAvailability() {
            const pickUpAvailability = document.querySelector('pickup-availability');
            if (!pickUpAvailability) return;
        
            if (this.currentVariant && this.currentVariant.available) {
              pickUpAvailability.fetchAvailability(this.currentVariant.id);
            } else {
              pickUpAvailability.removeAttribute('available');
              pickUpAvailability.innerHTML = '';
            }
         }
    })
}

if (!customElements.get('color-swatch')) {
    customElements.define('color-swatch', class ColorSwatch extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('change', this.onColorChange);
            this.label = this.parentNode.querySelector('.product-option-label')
            this.input = this.querySelector('.product-option-value-input')
            if(this.input.checked){
                this.label.innerHTML = `${this.dataset.option}: ${this.dataset.value}`;
            }             
        }

        onColorChange() {
            if(this.input.checked){
                this.label.innerHTML = `${this.dataset.option}: ${this.dataset.value}`;
            } 
        }
    })
}